// extracted by mini-css-extract-plugin
module.exports = {"main":"GeoModule_main__93vFc","list":"GeoModule_list__3ZwcO","actions":"GeoModule_actions__6ID_H","content":"GeoModule_content__3a0kq"};